





import { useFetch } from '@nuxtjs/composition-api';
import { defineComponent, ref } from '@vue/composition-api'
import axios from 'axios';
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ProductType } from '~/types/solepro/PageBuilder';
import ProductBox from '~/components/solepro/MenuProductBox.vue';

export default defineComponent({
    mixins: [PageBuilderComponent],
    components:{
        ProductBox
    },
    props: {
        node: {
            type: Object as PropType<ProductType>,
            required: true
        },
        customTag:{
            type: String,
            required: false
        }
    },
    setup(props) {
        /** @TODO manage carousel vs grid (now is only stacked grid) */
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const products = ref(null);
        useFetch(async ()=>{
        const skus = content.skus ? content.skus : content.children[0].skus
            if(skus.length>0){
                const res = await axios.post('/sole-api/product/pro/getProductBaseDataForBox', {skus})
                products.value = res.data;
            }
        })
        return { content, products }
    },
})
